import * as React from "react";
import { ProtectedVideo } from "./ProtectedVideo.jsx";

function VideoPreview({
  release,
  enabled,
  onOpenComic,
  hasFullAccess,
  onLockedClick,
  onUnauthorized,
}) {
  const { video } = release;
  const [failed, setFailed] = React.useState(false);
  const [attempt, setAttempt] = React.useState(0);
  const title = video.title || release.name;
  const poster = video.poster || release.thumbnail;

  return (
    <article className="video-card">
      {video.protected ? (
        <ProtectedVideo
          comicId={release.id}
          title={title}
          poster={poster}
          enabled={enabled}
          hasFullAccess={hasFullAccess}
          onLockedClick={onLockedClick}
          onUnauthorized={onUnauthorized}
        />
      ) : (
        <div className="video-preview-media">
          {video.previewSrc && !failed ? (
            <video
              key={attempt}
              controls
              playsInline
              preload="none"
              poster={poster}
              src={enabled ? video.previewSrc : undefined}
              aria-label={`Video preview: ${title}`}
              onError={() => setFailed(true)}
              onPlay={(event) => {
                const current = event.currentTarget;
                current
                  .closest("section")
                  .querySelectorAll("video")
                  .forEach((other) => {
                    if (other !== current) other.pause();
                  });
              }}
            />
          ) : (
            <div className="video-preview-unavailable">
              <img src={poster} alt="" loading="lazy" />
              <div
                className="video-preview-message"
                role={failed ? "status" : undefined}
              >
                <span>
                  {failed
                    ? "This preview could not be loaded."
                    : "Preview coming soon"}
                </span>
                {failed && (
                  <button
                    type="button"
                    className="button button-secondary"
                    onClick={() => {
                      setAttempt((value) => value + 1);
                      setFailed(false);
                    }}
                  >
                    Try again
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <div className="video-card-copy">
        <span className="comic-video-label">
          {video.protected
            ? "Members video"
            : "Video preview"}
        </span>
        <h3>{title}</h3>
        {video.description && <p>{video.description}</p>}
        <button
          type="button"
          className="video-chapter-link"
          onClick={() => onOpenComic(release.id)}
        >
          Read the chapter <span aria-hidden="true">→</span>
        </button>
      </div>
    </article>
  );
}

export function VideoPreviews({
  releases,
  enabled,
  onOpenComic,
  hasFullAccess,
  onLockedClick,
  onUnauthorized,
}) {
  return (
    <section
      className="home-section video-section"
      aria-labelledby="latest-videos-title"
    >
      <div className="home-section-heading">
        <h2 id="latest-videos-title" className="home-section-title">
          Latest videos
        </h2>
      </div>
      {releases.length > 0 ? (
        <div
          className={`video-list${releases.length === 1 ? " video-list--single" : ""}`}
        >
          {releases.map((release) => (
            <VideoPreview
              key={release.id}
              release={release}
              enabled={enabled}
              onOpenComic={onOpenComic}
              hasFullAccess={hasFullAccess}
              onLockedClick={onLockedClick}
              onUnauthorized={onUnauthorized}
            />
          ))}
        </div>
      ) : (
        <div className="video-coming-soon">
          <span className="video-coming-soon-icon" aria-hidden="true">
            ▶
          </span>
          <div>
            <p>Animated previews are on the way.</p>
            <span>Discover the first video here soon.</span>
          </div>
          <span className="comic-video-label">Coming soon</span>
        </div>
      )}
    </section>
  );
}
